import { Box, Button, Typography } from "@mui/joy";
import Add from "@mui/icons-material/Add";
import React, { useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import GenericTableView from "../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../enum/TableView";
import { MenuItem } from "primereact/menuitem";
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { removeClient, updateClient } from "../../service/clientService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { RouteComponentProps } from "../../models/RouteComponent";
import { v4 as uuid } from "uuid";
import { useNavigate } from "react-router-dom";
import { removeEmployee, updateEmployee } from "../../service/employeeService";
import ClientAdminAddView from "./client-admin-Add";

export default function ClientAdminTable(props: RouteComponentProps) {
  const navigate = useNavigate();

  const session = props.session;

  const client = session.client_id;

  const [selectedRecord, setSelectedRecord] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);

  const toast = useRef(null as any);

  let url = "client_admin";

  const baseFilter = {
    full_name: { value: "", matchMode: FilterMatchMode.CONTAINS },
    id_number: { value: "", matchMode: FilterMatchMode.CONTAINS },
    active: { value: null, matchMode: FilterMatchMode.CONTAINS },
  };

  const deleteButton = (row: any) => {
    console.log("deleteButton row == ", selectedRecord);
    removeClient(selectedRecord.id);
  };

  const addButton = (row: any) => {
    console.log("addButton row == ", row);
    setSelectedRecord(null);
    // props.setGlobalLoader(true);
    setVisible(true);
  };

  const itemSelected = (row: any) => {
    const value = row.value;
    console.log("value == ", value);
    setSelectedRecord(value);
    viewSelected(row);
  };

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row);
    setSelectedRecord(row.value);
  };

  const acceptFunc = async () => {
    props.setGlobalLoader(true);
    const client = await removeEmployee(selectedRecord.id);
    props.setGlobalLoader(false);
    toast.current.show({
      severity: "success",
      summary: "Employee Deleted Successfully",
      life: 3000,
    });
  };

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: "Are you sure you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => acceptFunc(),
    });
  };

  const changeStatusFunc = async (status: boolean) => {
    props.setGlobalLoader(true);
    const client = await updateEmployee({ active: status }, selectedRecord.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({
      severity: "success",
      summary: status ? "Employee Activated Successfully" : "Employee Deactivated Successfully",
      life: 3000,
    });
  };

  const disableConfirm = (row: any) => {
    confirmDialog({
      message: "Are you sure you want to deactivate employee?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => changeStatusFunc(false),
    });
  };

  const activateConfirm = (row: any) => {
    confirmDialog({
      message: "Are you sure you want to activate employee?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => changeStatusFunc(true),
    });
  };

  const DialogSetVisible = (row: any) => {
    setVisible(true);
  };

  const viewSelected = (row: any) => {
    setVisible(true);
  };

  const contextItems = () => {
    let objArray = [{ label: "Edit", icon: "pi pi-fw pi-pencil", command: viewSelected }];
    if (selectedRecord?.active) {
      objArray.push({
        label: "Deactivate",
        icon: "pi pi-fw pi-times-circle",
        command: disableConfirm,
      });
    } else {
      objArray.push({
        label: "Activate",
        icon: "pi pi-fw pi-check-circle",
        command: activateConfirm,
      });
    }
    objArray.push({ label: "Delete", icon: "pi pi-fw pi-trash", command: deleteConfirm });
    return objArray;
  };

  const columns: GenericTableColumns[] = [
    {
      field: "full_name",
      header: "Full Name",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "id_number",
      header: "ID Number",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "",
      header: "ContactDetails",
      type: GenericTableColumTypes.Contact,
      visible: true,
      sort: false,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
      contactDetails: {
        cellField: "mobile",
        emailField: "email",
        labelField: "full_name",
        avatarSrc: "photo",
      },
    },
    {
      field: "active",
      header: "Active",
      type: GenericTableColumTypes.Boolean,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Boolean,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
  ];

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          mb: 1,
          gap: 1,
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "start", sm: "center" },
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <Typography level="h2" component="h1">
          Admin
        </Typography>

        {/* <Button
            color="primary"
            startDecorator={<Add />}
            size="sm"
            onClick={() => setVisible(true)}
          >Add</Button> */}
      </Box>

      <GenericTableView
        reload={reload}
        baseFilters={baseFilter}
        url={url}
        columns={columns}
        contextItems={contextItems}
        addButton={addButton}
        itemSelect={itemSelected}
        contextItemSelected={contextItemSelected}
      />

      <Dialog
        header={selectedRecord?.id ? "Update Admin" : "Add Admin"}
        visible={visible}
        style={{ width: "50vw" }}
        onHide={() => setVisible(false)}
      >
        <ClientAdminAddView
          setGlobalLoading={props.setGlobalLoader}
          record={selectedRecord}
          setReload={setReload}
          reload={reload}
          uuid={uuid()}
          setVisible={setVisible}
          toast={toast}
          session={props.session}
          clientId={client}
        />
      </Dialog>

      <ConfirmDialog />

      <Toast ref={toast} />
    </React.Fragment>
  );
}
